// Normalizes United Detergents' two invoices, built by functions/builders/udBuilder.js.
// Unlike ARSL/ATL/ES/Sefam, both documents here carry more than one line
// category each — payroll + service charge + GST together on invoice 1,
// resource cost + EOBI + PESSI together on invoice 2 — so they don't fit the
// generic engine's single reimbursement/service split.
import { LINE_CATEGORIES, makeLine } from "../lineCategories";

function normalizePayrollInvoice(sourceDoc) {
  const monthlySalaries = Number(sourceDoc.monthlySalaries || 0);
  const loadingUnloading = Number(sourceDoc.loadingUnloading || 0);
  const serviceCharges = Number(sourceDoc.serviceCharges || 0);
  const gstAmount = Number(sourceDoc.gst || 0);
  const grossAmount = Number(sourceDoc.grandTotal || 0);

  const lines = [
    makeLine({ category: LINE_CATEGORIES.SALARY_REIMBURSEMENT, description: "Monthly salaries reimbursement", amount: monthlySalaries, sourceField: "monthlySalaries" })
  ];
  if (loadingUnloading) {
    lines.push(makeLine({ category: LINE_CATEGORIES.SALARY_REIMBURSEMENT, description: "Loading & unloading bill reimbursement", amount: loadingUnloading, sourceField: "loadingUnloading" }));
  }
  lines.push(makeLine({ category: LINE_CATEGORIES.SERVICE_CHARGE, description: "Service charges @ 6%", amount: serviceCharges, sourceField: "serviceCharges" }));
  lines.push(makeLine({ category: LINE_CATEGORIES.GST, description: "GST on service charges @ 16%", amount: gstAmount, sourceField: "gst" }));

  return { lines, serviceChargeSubtotal: serviceCharges, invoiceAmount: monthlySalaries + loadingUnloading, gstAmount, grossAmount, recoveryBase: null, recoveryAddBack: null };
}

function normalizeStatutoryInvoice(sourceDoc) {
  const resourceCostTotal = Number(sourceDoc.resourceCostTotal || 0);
  const eobiTotal = Number(sourceDoc.eobiTotal || 0);
  const pessiTotal = Number(sourceDoc.pessiTotal || 0);
  const grossAmount = Number(sourceDoc.grandTotal || (resourceCostTotal + eobiTotal + pessiTotal));

  const lines = [
    makeLine({ category: LINE_CATEGORIES.SALARY_REIMBURSEMENT, description: "Resource cost reimbursement (dedicated ALM staff)", amount: resourceCostTotal, sourceField: "resourceCostTotal" }),
    makeLine({ category: LINE_CATEGORIES.EOBI_RECOVERY, description: "EOBI reimbursement", amount: eobiTotal, sourceField: "eobiTotal" }),
    makeLine({ category: LINE_CATEGORIES.PESSI_RECOVERY, description: "PESSI reimbursement", amount: pessiTotal, sourceField: "pessiTotal" })
  ];

  return { lines, serviceChargeSubtotal: 0, invoiceAmount: grossAmount, gstAmount: 0, grossAmount, recoveryBase: null, recoveryAddBack: null };
}

export function normalizeUdInvoice(sourceDoc) {
  if (sourceDoc.type === "ud-payroll") return normalizePayrollInvoice(sourceDoc);
  if (sourceDoc.type === "ud-statutory") return normalizeStatutoryInvoice(sourceDoc);
  throw new Error(`Unknown United Detergents invoice type: ${sourceDoc.type}`);
}
